import { LinkAndDocument } from '@/@types'
import { Svg } from '@/components'
import { ColumnHeader } from '@/components/data-table/column-header'
import { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'

export const TABLE_COLUMNS: ColumnDef<LinkAndDocument>[] = [
  {
    id: 'label',
    accessorKey: 'label',
    header: ({ column }) => <ColumnHeader column={column} title="Nome" />,
    cell: ({ row }) => (
      <div className="flex gap-2 items-center">
        {row.original.type === 'DOCUMENT' ? (
          <Svg src="/icons/documents.svg" className="max-w-6" />
        ) : (
          <Svg src="/icons/link.svg" className="max-w-6" />
        )}
        <span>{row.original.label}</span>
      </div>
    ),
  },
  {
    id: 'lesson',
    accessorKey: 'lesson',
    header: ({ column }) => (
      <ColumnHeader column={column} title="Nome da lição" />
    ),
    cell: ({ row }) => row.original?.lesson?.title,
  },
  {
    id: 'size',
    accessorKey: 'size',
    header: ({ column }) => <ColumnHeader column={column} title="Tamanho" />,
    cell: ({ row }) =>
      `${row.original.type === 'DOCUMENT' && row.original.size ? `${row.original.size}mb` : '---'}`,
  },
  {
    id: 'level',
    accessorKey: 'level',
    header: ({ column }) => <ColumnHeader column={column} title="Nível" />,
    cell: ({ row }) => {
      const level = row.original?.lesson?.module.level
      return level ? `Nível ${level}` : '---'
    },
    filterFn: (row, _, value) => {
      const lessonLevel = row.original.lesson?.module.level

      if (!value || value.length === 0) {
        return true
      }

      const filterLevels = Array.isArray(value)
        ? value.map((v) => parseInt(v.replace('level ', '')))
        : [parseInt(value.replace('level ', ''))]

      return filterLevels.includes(lessonLevel)
    },
  },
  {
    id: 'createdAt',
    accessorKey: 'createdAt',
    header: ({ column }) => (
      <ColumnHeader column={column} title="Data de criação" />
    ),
    cell: ({ row }) => format(row.original.createdAt, 'dd/mm/yyyy'),
  },
]
